import { createModule } from '@dynapp/wc-api-generic'

export default createModule({
  entitySingular: 'category',
  entityPlural: 'categories',
  dataObject: 'dync-appshop-web',
  mode: process.env.NODE_ENV,
  state: {
    publishable: false
  }
});
